const getPositionChange = myScore => {
    if (!myScore || myScore.positionChange === undefined) {
        return null;
    }

    return parseInt(myScore.positionChange, 10);
};

export { getPositionChange as default };
